import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';

let naviTimerNum = 0;
const NaviURL = forwardRef((props, ref) => {
  let {
    naviToggle, naviSearch, setNaviSearch, setNaviStart, setNaviEnd, isShowNavi, naviStart, naviEnd, map, isRouteRendered
  } = props;
  let [isURLParseDone, setIsURLparseDone] = useState(false);
  let [naviDuaringSearch, setNaviDuaringSearch] = useState(false);

  useImperativeHandle(ref, () => ({
    setNaviURLParam: setNaviURLParam
  }));

  // ナビをオープンするパラメータを判別して表示する
  const openNaviFromParam = () => {
    let urlSearchParam = new URLSearchParams(window.location.search);
    let n_mode = new URLSearchParams(window.location.search).get("n_mode");
    let isNMode = n_mode && /0|1|2|3/.test(n_mode);
    if(urlSearchParam.get("n_type") || isNMode){
      naviToggle(true); // n_type、n_modeパラメータがある場合はナビを表示状態にする
    }
  }

  const naviParamParse = ()=>{
    // 一旦泥臭く設定してみる TODO: なにかスマートな方法が思い浮かんだらそれで実装してみる
    let urlSearchParam = new URLSearchParams(window.location.search);
    let naviData = {drive:{}, walk:{}, transit:{}};

    // ナビの種別 ドライブルート、徒歩、電車
    if(urlSearchParam.get("n_type")){
      let paramType = urlSearchParam.get("n_type");
      naviData["type"] = {
          d: "drive",
          w: "walk",
          t: "transit"
      }[paramType] || "drive";
    }

    // ドライブルートのパラメータ処理
    Object.keys(naviSearch.drive).forEach((key)=>{
      let driveVal = urlSearchParam.get(`n_${key}`);
      if(driveVal && !(key === "type")){ // n_typeは反映させないようにする
        naviData.drive[key] = !Number.isNaN(Number(driveVal))? Number(driveVal): driveVal; // 数字の場合は数値として扱い、その他の場合はそのまま
      }
    });

    // 徒歩ルートのパラメータ処理
    // 徒歩ルートはpscしかない
    if(urlSearchParam.get("n_psc")) {
      naviData.walk["psc"] = Number(urlSearchParam.get("n_psc"));
    }

    // 乗り換え徒歩ルートのパラメータ処理
    Object.keys(naviSearch.transit).forEach((key)=>{
      let transitVal = urlSearchParam.get(`n_${key}`);
      if(transitVal && key==="date"){
        // パラメータのdateは yyyymmddHHMM になっているのでdateとtimeに分離する
        naviData.transit["date"] = transitVal.substring(0, 8);
        naviData.transit["time"] = transitVal.substring(8, 12);
      } else if(transitVal && key==="mode"){
        // パラメータのmodeは 出発、始発などのtransitModeの値になる
        naviData.transit["transitMode"] = Number(transitVal);
        if(transitVal && /0|1|2|3/.test(transitVal)){
          naviData["type"] = "transit"; // 旧地図のパラメータ仕様でn_modeが存在する場合は乗換徒歩ルートに切り替える仕様があったのでそれを踏襲する
        }
      } else if(transitVal){
        naviData.transit[key] = transitVal;
      }
    });


    // 飛行機、新幹線、有料特急の処理
    if(["n_air", "n_shinkansen", "n_express"].some((key)=> urlSearchParam.get(key))){
      let air = urlSearchParam.get("n_air") === '1'? 0: 2; // 0:利用する 2:利用しない
      let shinkansen = urlSearchParam.get("n_shinkansen") === '1'? 0: 2;
      let exp = urlSearchParam.get("n_express") === '1'? 0: 2;

      naviData.transit["transportation"] = `00${air}${shinkansen}${exp}${exp}${exp}0`;
    }

    // ソート条件
    if(urlSearchParam.get("n_sort")){
      naviData.transit["sort"] = [
        'time,fare,transfer', //  時間順
        'fare,time,transfer', //  料金順
        'transfer,fare,time'  //  乗り換え順
      ][Number(urlSearchParam.get("n_sort"))] || 'time,fare,transfer';
    }

    // 発着の設定
    let startData = {name: null, lat: null, lon:null};
    ["n_start", "n_start_name", "n_start_lat", "n_start_lon"].forEach((key)=>{
      let startVal = urlSearchParam.get(key);
      if(key === "n_start" && startVal){ // n_startの場合はnameとして扱い、強制的に検索したデータでセットされる
          startData.name = startVal;
          startData.forceSearch = true;
      } else if(startVal && typeof startData[key.replace("n_start_", "")] !== "undefined"){
        startData[key.replace("n_start_", "")] = startVal;
      }
    });
    if(startData.name === null && startData.lat && startData.lon ){
      // 名称がないけど緯度経度がある場合は強制的に住所を取得したデータがセットされる
      startData.forceSearch = true;
    }
    setNaviStart(startData);

    let endData = {name: null, lat: null, lon:null};
    ["n_end", "n_end_name", "n_end_lat", "n_end_lon"].forEach((key)=>{
      let endVal = urlSearchParam.get(key);
      if(key === "n_end" && endVal){ // n_endの場合はnameとして扱い、強制的に検索したデータでセットされる
        endData.name = endVal;
        endData.forceSearch = true;
      } else if(endVal && typeof endData[key.replace("n_end_", "")] !== "undefined"){
        endData[key.replace("n_end_", "")] = endVal;
      }
    });
    if(endData.name === null && endData.lat && endData.lon ){
      // 名称がないけど緯度経度がある場合は強制的に住所を取得したデータがセットされる
      endData.forceSearch = true;
    }
    setNaviEnd(endData);

    // 経由地
    for(let i=1; i <= 5; i++) {
      let viaData = {name: null, lat: null, lon:null};
      ["n_via", "n_via_name", "n_via_lat", "n_via_lon"].forEach((key)=>{
        let viaKey = key + i; 
        let viaVal = urlSearchParam.get(viaKey);
        if(key === "n_via" && viaVal){ // n_viaX の場合はnameとして扱い、検索を実施して緯度経度を取得
          viaData.name = viaVal;
          viaData.forceSearch = true;
        } else if(viaVal && typeof viaData[key.replace("n_via_", "")] !== "undefined"){
          viaData[key.replace("n_via_", "")] = viaVal;
        }
      });
      let naviSetter = props["setNaviVia" + i];
      // ナビはいずれかの項目がない場合は追加しない
      if(viaData.name !== null || viaData.lat !== null || viaData.lon !== null){
        if(viaData.name === null && viaData.lat && viaData.lon ){
          // 名称がないけど緯度経度がある場合は強制的に住所を取得したデータがセットされる
          viaData.forceSearch = true;
        }
        naviSetter(viaData);
      }
    }

    let extendNaviSearch = window.$.extend(true, naviSearch, naviData);

    setNaviSearch({...naviSearch, extendNaviSearch})
  }

  useEffect(()=>{
    clearTimeout(naviTimerNum);
    if(naviDuaringSearch && isRouteRendered){ // 初期のURLパース時に検索途中であることをフラグ立ててURLの削除を防いでいる
      setNaviDuaringSearch(false);
    }
    if(!isURLParseDone){
      openNaviFromParam();
      // URLからナビのパラメータをパースしてセット
      let type = new URLSearchParams(window.location.search).get("n_type");
      let n_mode = new URLSearchParams(window.location.search).get("n_mode");
      let isNMode = n_mode && /0|1|2|3/.test(n_mode);
      if(type || isNMode){
        setNaviDuaringSearch(true);
        map.on('load', () => { // 地図の準備ができてからURLをパースする
          naviParamParse();
        })
      }
      setIsURLparseDone(true);
    } else {
      // ナビが表示されてないとき。もしくはルート検索結果が無い、かつ、検索途中ではない時はナビのパラメータを削除する
      if(!isShowNavi || (isShowNavi && !isRouteRendered && !naviDuaringSearch)){
        naviTimerNum = setTimeout(()=>{ // replaceStateを叩きすぎるとsafariで落ちるので対策する
          deleteNaviParam();
        }, 100);
      }
    }
  }, [isShowNavi, map, naviParamParse, openNaviFromParam, setIsURLparseDone]);

  const setNaviURLParam = () => {
    deleteNaviParam(); // パラメータを初期化
    let params = [];
    let {type, drive, walk, transit} = naviSearch;

    // 発
    let {name: startName, lat: startLat, lon: startLon} = naviStart;
    if(startName) params.push({key: "n_start_name", value: encodeURIComponent(startName)});
    if(startLat && startLon){
      params.push({key: "n_start_lat", value: startLat});
      params.push({key: "n_start_lon", value: startLon});
    }

    // 着
    let {name: endName, lat: endLat, lon: endLon} = naviEnd;
    if(endName) params.push({key: "n_end_name", value: encodeURIComponent(endName)});
    if(endLat && endLon){
      params.push({key: "n_end_lat", value: endLat});
      params.push({key: "n_end_lon", value: endLon});
    }

    // ドライブのパラメータ
    if(type === "drive"){
      params.push({key: "n_type", value: "d"});
      // 詳細設定
      ["chg", "vt", "smartic"].forEach((key)=> {
        params.push({key: `n_${key}`, value: drive[key]});
      });

      // 有料道路上に設定
      ["st_road_type", "ed_road_type", "m_road_type1", "m_road_type2", "m_road_type3", "m_road_type4", "m_road_type5"]
        .filter(key => drive[key] !== 1) // フラグが立ってない場合は設定しない
        .forEach(key => params.push({key: `n_${key}`, value: drive[key]}))

      // 経由地
      for(let i=1; i <= 5; i++) {
        let viaData = props[`naviVia${i}`];
        if(!viaData) continue; // データが無かった場合はスキップ
        let {name: viaName, lat: viaLat, lon: viaLon} = viaData;
        if(viaName) params.push({key: `n_via_name${i}`, value: encodeURIComponent(viaName)});
        if(viaLat && viaLon){
          params.push({key: `n_via_lat${i}`, value: viaLat});
          params.push({key: `n_via_lon${i}`, value: viaLon});
        }
      };
    }

    // 徒歩のパラメータ
    if(type === "walk"){
      params.push({key: "n_type", value: "w"});
      params.push({key: "n_psc", value: walk["psc"]});
    }

    // 電車・徒歩
    if(type === "transit"){
      let {date, time, transitMode, transportation, sort} = transit;
      params.push({key: "n_type", value: "t"});
      params.push({key: "n_date", value: `${date}${time}`});
      params.push({key: "n_mode", value: transitMode});

      // 飛行機、新幹線、有料特急の
      let [, , air, shinkansen, express] = transportation;
      params.push({key: "n_air", value: +air ===0? 1: 0}); // 0: 利用する 2: 利用しない
      params.push({key: "n_shinkansen", value: +shinkansen ===0? 1: 0});
      params.push({key: "n_express", value: +express ===0? 1: 0});

      // ソート順
      let transitSortNum= [ // sort順 0:時間順 1:料金順 2:乗換
        'time,fare,transfer', //  時間順
        'fare,time,transfer', //  料金順
        'transfer,fare,time'  //  乗り換え順
      ].reduce((acc, val, i)=>{
        return sort === val? i : acc;
      }, 0);
      params.push({key: "n_sort", value: transitSortNum});
    }

    let paramString = params.map(({key, value})=> `${key}=${value}`).join("&");
    window.history.replaceState(null, null, `${window.location.pathname}?${paramString}`);
  }

  const deleteNaviParam = ()=>{
    // ナビ関連以外のパラメータを保持
    let naviOtherParamString = window.location.search
      .substring(1)
      .split("&")
      .filter((v)=> !v.split("=")[0].match(/n_/)) // naviのパラメータは必ずn_で始まるのでそれを除去する
      .join();

    window.history.replaceState(null, null, `${window.location.pathname}${naviOtherParamString!==""? `?${naviOtherParamString}`: ""}`);
  }

  return (
    <></>
  );
});

export default NaviURL;